import { render, staticRenderFns } from "./MyServiceRequest.vue?vue&type=template&id=f87dddf8&scoped=true&"
import script from "./MyServiceRequest.vue?vue&type=script&lang=js&"
export * from "./MyServiceRequest.vue?vue&type=script&lang=js&"
import style0 from "./MyServiceRequest.vue?vue&type=style&index=0&id=f87dddf8&prod&lang=scss&scoped=true&"
import style1 from "./MyServiceRequest.vue?vue&type=style&index=1&id=f87dddf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87dddf8",
  null
  
)

export default component.exports